import { graphql, useStaticQuery } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";
import { Languages } from "@/src/types";


export type Props = {
  allWpNyhet: {
    nodes: {
      url: string;
      title: string;
      slug: string;
      published_at: string;
      description: string;
      image_url: string;
      image: {
        childImageSharp: {
          gatsbyImageData: ImageDataLike;
        };
      };
      contentType: {
        node: {
          graphqlSingleName: string;
        };
      };
    }[];
  };
};

export const usePostsWPSettingsData = (lang: Languages) => {

  const { wp } = useStaticQuery(graphql`
    {
        wp {
      siteSettingsSV {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
                cptNewsLabel
                cptNewsSingularLabel
              }
            }
          }
          siteSettingsEN {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
                cptNewsLabel
                cptNewsSingularLabel
              }
            }
          }
          siteSettingsZH {
            acf_settings {
              labels {
                signUpLabel
                cookieHeaderLabel
                cookieTextLabel
                acceptLabel
                declineLabel
                cptNewsLabel
                cptNewsSingularLabel
              }
            }
          }
        }
  }`);


  return wp[`siteSettings${lang.toUpperCase()}`].acf_settings.labels;
};